import axios from 'axios';
import http from 'http';
import https from 'https';
import { getExternalFeedUrl } from 'helpers/feeds/generalHelpers';
import {
  getSiteDomain,
  getHash,
  getParsedJson,
  debugLogs,
  getS2Sdomain,
} from '../utils/common';

class MakeRequestClass {
  constructor(obj) {
    this.enableWebWorker =
      typeof window !== 'undefined' && typeof Worker === 'function';
    this.requestPromises = {};
    const isConnectionAlive = typeof window === 'undefined';
    const httpAgent = new http.Agent({ keepAlive: isConnectionAlive });
    const httpsAgent = new https.Agent({ keepAlive: isConnectionAlive });
    this.axiosInstance = axios.create({
      ...obj,
      httpAgent,
      httpsAgent,
    });
    if (this.enableWebWorker) {
      try {
        window.isRequestWorkerInitialized = true;
        this.worker = new Worker('/assets/request_worker.js');
        this.worker.onerror = event => {
          // this get calls after makerequest object is freeze, hence can't add in this.
          // eslint-disable-next-line no-console
          debugLogs('error webworker', event);
          window.isRequestWorkerInitialized = false;
        };
        // binding event
        this.worker.onmessage = event => {
          const parsedJson = getParsedJson(event.data);
          const { status, webWorkerKey } = parsedJson;
          if (this.requestPromises[webWorkerKey]) {
            if (status >= 200 && status < 300) {
              this.requestPromises[webWorkerKey].resolve(parsedJson);
            } else {
              this.requestPromises[webWorkerKey].reject({
                response: parsedJson,
                request: parsedJson.request,
                config: parsedJson.config,
                message: `Getting Error while hitting ${webWorkerKey}`,
              });
            }
            delete this.requestPromises[webWorkerKey];
          }
        };
      } catch (err) {
        window.isRequestWorkerInitialized = false;
      }
    }
  }

  static appendDomainToUrl(url, params) {
    let isRelativeUrl;
    const endpointData = [];

    const domain = getSiteDomain();

    if (url && typeof url === 'string') {
      isRelativeUrl = url.indexOf('http') === -1 && url.indexOf('.com') === -1;
    }
    if (isRelativeUrl) {
      if (params[2] !== 'skipfeedengine') {
        endpointData.push(getExternalFeedUrl());
      }
      if (url[0] === '/') {
        endpointData.push(domain);
      } else {
        endpointData.push(domain);
        endpointData.push('/');
      }
    }
    endpointData.push(url);
    if (
      typeof window === 'undefined' &&
      Array.isArray(endpointData) &&
      endpointData.length > 0
    ) {
      endpointData[0] = endpointData[0]
        .replace(domain, getS2Sdomain())
        .replace(
          'https://toifeeds.indiatimes.com/treact',
          'https://int-toifeeds.indiatimes.com',
        );
    }
    return endpointData.join('');
  }

  static handleError(error) {
    // This to protect logging on client side
    if (typeof window !== 'undefined') {
      return;
    }
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error(
        'TOI_SPA_V2_LOG - Error in axios',
        error.response.status,
        error.response.data,
        error.response.headers,
      );
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.error('TOI_SPA_V2_LOG - Error in axios', error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('TOI_SPA_V2_LOG - Error in axios', error.message);
    }
  }

  getWebWorkerPromise(method, params) {
    let key;
    try {
      if (method === 'GET') {
        key = `${params[0]}_${Date.now()}`;
      } else {
        key = `${params[0]}_${getHash(params[1] || '')}`;
      }

      const pmObject = JSON.parse(
        JSON.stringify({
          method,
          params,
          webWorkerKey: key,
        }),
      );

      this.worker.postMessage(pmObject);
      return new Promise((resolve, reject) => {
        this.requestPromises[key] = {
          resolve,
          reject,
        };
      });
    } catch (err) {
      return new Promise((resolve, reject) => {
        reject();
      });
    }
  }

  getURL = params => {
    let url = '';
    let urlParamString = '';
    if (params.length > 0) {
      url = params[0];
      const { params: urlParams } = params[1] || {};
      if (typeof urlParams === 'object') {
        urlParamString = Object.keys(urlParams)
          .map(key => `${key}=${urlParams[key]}`)
          .join('&');
      }
      const urlCombiner = url.indexOf('?') > -1 ? '&' : '?';
      url = urlParamString ? `${url}${urlCombiner}${urlParamString}` : url;
    }
    return url;
  };

  IsValiderRequestCallViaWorker = (params = []) => {
    let isWhiteList = false;
    const url = params[0] || '';
    const { skipWebWorker } = params[1] || {};
    if (skipWebWorker) {
      return false;
    }
    const whiteListToiFeedArray = [
      '/toifeeds.indiatimes.com/treact/',
      '/pwastg.timesofindia.com/feeds/',
    ];
    const whiteListXSLTArray = [
      '/timesofindia.indiatimes.com/',
      '/m.timesofindia.com/',
    ];
    const whiteListJarvisArray = ['/jarvis.indiatimes.com/'];
    const whiteListS3Feeds = ['/toibnews.timesofindia.indiatimes.com/'];

    const whiteListArray = [
      ...whiteListToiFeedArray,
      ...whiteListXSLTArray,
      ...whiteListJarvisArray,
      ...whiteListS3Feeds,
    ];
    for (let i = 0; i < whiteListArray.length; i += 1) {
      if (url.includes(whiteListArray[i])) {
        isWhiteList = true;
        break;
      }
    }

    return isWhiteList;
  };

  get() {
    const params = Object.assign([], arguments);
    params[0] = MakeRequestClass.appendDomainToUrl(params[0], params);
    //@todo can we use __PROD__ for this rather than params[0] ?
    if (
      params[0].includes('toifeeds') ||
      params[0].includes('pwastg') ||
      params[0].includes('localhost')
    ) {
      // if (global.upcache) {
      //   params[0] += '&upcache=2';
      // }
      //@todo from it's getting set ? do we have to check this in all the request ?
      const isMobileArgument = !!(
        params.length > 1 &&
        params[1] &&
        params[1].isMobile
      );

      if (isMobileArgument) {
        params[0] += '&ismobile=true';
      }
    }
    if (
      this.enableWebWorker &&
      window.isRequestWorkerInitialized &&
      this.IsValiderRequestCallViaWorker(params)
    ) {
      params[0] = this.getURL(params);
      // console.log(`pfTesting webworker get ${params[0]}`);
      // console.count(`pfTesting webworker get calls count`);
      return this.getWebWorkerPromise('GET', params).catch(err => {
        MakeRequestClass.handleError(err);
        return Promise.reject(err);
      });
    }
    // console.log(`pfTesting axios get ${params[0]}`);
    // console.count(`pfTesting axios get calls count`);
    return this.axiosInstance.get.apply(null, params).catch(err => {
      MakeRequestClass.handleError(err);
      return Promise.reject(err);
    });
  }

  getwap() {
    const params = Object.assign([], arguments);
    params[0] = MakeRequestClass.appendDomainToUrl(params[0], params);
    return this.axiosInstance.get.apply(null, params).catch(err => {
      MakeRequestClass.handleError(err);
      return Promise.reject(err);
    });
  }

  post() {
    const params = Object.assign([], arguments);
    params[0] = MakeRequestClass.appendDomainToUrl(params[0]);
    // if (
    //   this.enableWebWorker &&
    //   window.isRequestWorkerInitialized &&
    //   this.IsValiderRequestCallViaWorker(params, 'POST')
    // ) {
    //   console.count(`pfTesting webworker post calls count ${params[0]}`);
    //   return this.getWebWorkerPromise('POST', params).catch(err => {
    //     MakeRequestClass.handleError(err);
    //     return Promise.reject(err);
    //   });
    // }
    // console.log(`pfTesting axios pist ${params[0]}`);
    // console.count(`pfTesting axios post calls count ${params[0]}`);
    return this.axiosInstance.post.apply(null, params).catch(err => {
      MakeRequestClass.handleError(err);
      return Promise.reject(err);
    });
  }
}

const makeRequest = new MakeRequestClass();

Object.freeze(makeRequest);

export default makeRequest;
